const Certificate_Api = [
    {
      id: 1,
      category: "education",
      year: "March 2020 - November 2020",
      title: "Web Development & Digital Marketing (SEO, SMM, WordPress and Google Ads) Certification",
      desc: "Institute: Clariwell Global Services LLP, Pune.",
    },
  ]
  
  export default Certificate_Api
  